import type { ContentDocument, DiagnosticOption, DiagnosticQuestionType } from "src/services/diagnosticService";
import { ContentBlocks } from "src/components/assessment/ContentBlocks";
import { FibInput } from "src/components/assessment/FibInput";
import { OptionsMCQ } from "src/components/assessment/OptionsMCQ";
import { TrueFalseButtons } from "src/components/assessment/TrueFalseButtons";

interface QuestionRendererProps {
  type: DiagnosticQuestionType;
  content: ContentDocument;
  options: DiagnosticOption[];
  answer: unknown;
  onChange: (answer: unknown) => void;
}

export function QuestionRenderer({ type, content, options, answer, onChange }: QuestionRendererProps) {
  return (
    <div className="flex flex-col gap-6">
      <ContentBlocks content={content} />
      {type === "TF" && (
        <TrueFalseButtons value={typeof answer === "boolean" ? answer : null} onChange={onChange} />
      )}
      {type === "MCQ-SC" && (
        <OptionsMCQ multiple={false} options={options} value={typeof answer === "string" ? answer : ""} onChange={onChange} />
      )}
      {type === "MCQ-MC" && (
        <OptionsMCQ multiple options={options} value={Array.isArray(answer) ? answer as string[] : []} onChange={onChange} />
      )}
      {type === "FIB" && (
        <FibInput
          content={content}
          value={answer && typeof answer === "object" && !Array.isArray(answer)
            ? ((answer as { blanks?: Record<string, string> }).blanks ?? answer as Record<string, string>)
            : {}}
          onChange={(blanks) => onChange({ blanks })}
        />
      )}
    </div>
  );
}

export default QuestionRenderer;
